module.exports = __webpack_public_path__ + "img/XT.9e26fbf5.png";